import css from "styled-jsx/css";
import { TOP_BAR } from "/constants/z-index";
import Constants from "segments/desktop/header/layouts/components/basic-header/constants";
import Colors from "styles/colors";
import { ALWAYS_ON_TOP } from "constants/z-index";
import {
  MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH,
  MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH,
  MD_DESKTOP_WIDTH,
  HEADER_DESKTOP_MENU_MID_WIDTH
} from "/constants/vp-sizes";
import {
  BACKGROUND_GRAY_COLOR_NAME,
  LIGHT_WORK_OS_IRIS_COLOR_NAME,
  DARK_WORK_OS_IRIS_COLOR_NAME
} from "styles/color-consts";
import { getComponentShadowFilter } from "segments/desktop/constants";
import HeaderConstants from "../constants";

const BASIC_HEADER_HEIGHT = `${Constants.BASIC_HEADER_HEIGHT}px`;
const SECONDARY_HEADER_HEIGHT = `${Constants.SECONDARY_HEADER_HEIGHT}px`;

const UNIFIED_HEADER_TRANSITION = `opacity ${HeaderConstants.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION}ms ease, transform ${HeaderConstants.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION}ms ease`;
const UNIFIED_HEADER_TRANSITION_LINKS_DISSAPPEAR = `opacity ${HeaderConstants.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION}ms ease, transform ${HeaderConstants.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION}ms ease`;

const SUBMENU_TRANSITION = "opacity 50ms ease";

const CONDENSED_HEADER_SCREEN_HEIGHT = "700px";

export const componentStyles = css.global`
  .base-header-desktop-component {
    width: 100%;

    .header-create-account-button-wrapper {
      .regular-button {
        height: 40px;
        .button-component {
          display: flex;
          height: 100%;
          align-items: center;
          font-size: 0.8125rem;
        }
      }
    }

    .header-button-wrapper {
      display: flex;
      align-items: center;
      padding-left: 16px;

      .signup-button {
        height: 40px;
      }
    }

    .signup-popup-wrapper {
      position: fixed;
      z-index: ${ALWAYS_ON_TOP};
      top: ${Constants.BASIC_HEADER_HEIGHT + 12} + "px";
      left: calc(
        (100vw - ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px) / 2 + ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px -
          ${Constants.SIGNUP_POPUP_SCREEN_WIDTH}px - ${Constants.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN}px
      );

      @media (max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH}) {
        left: calc(100vw - ${Constants.SIGNUP_POPUP_SCREEN_WIDTH}px - ${Constants.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN}px);
      }
    }

    &.scrolled-threshold {
      .base-header-desktop-content {
        .left-side-header-links {
          .absolute-main-links {
            opacity: 0;
            visibility: hidden;
            pointer-events: none;
            transform: translateY(-8px);
            transition: ${UNIFIED_HEADER_TRANSITION_LINKS_DISSAPPEAR};
          }

          .absolute-unified-links {
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
            transform: none;
            transition: ${UNIFIED_HEADER_TRANSITION};
          }
        }
      }

      .secondary-header-wrapper {
        pointer-events: none;
      }
    }

    .base-header-desktop-content {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: ${BASIC_HEADER_HEIGHT};

      .left-side-header-links,
      .right-side-header-links {
        height: 100%;
        display: flex;

        .link-item-with-menu-component-wrapper,
        .link-item-component-wrapper {
          display: flex;
          align-items: center;

          &.header-language-picker {
            justify-content: center;
            align-items: center;
            .language-picker-component {
              .selected-language {
                border-radius: 8px;
                padding: 0 16px;
                &:hover {
                  background-color: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};
                }
              }
              .earth-icon {
                margin: 0 6px;
                width: 18px;
                height: 18px;
              }
              .arrow-down-icon {
                height: 7px;
              }
              .language-picker-dialog-component-wrapper {
                top: 52px;
              }
            }
          }
        }
      }

      .left-side-header-links {
        flex-grow: 1;
        flex-shrink: 0;

        .absolute-unified-links,
        .absolute-main-links {
          position: absolute;
          display: flex;
          height: 100%;
        }
        .absolute-main-links {
          opacity: 1;
          visibility: visible;
          transition: ${UNIFIED_HEADER_TRANSITION};

          .submenu-enter {
            opacity: 0.01;
          }

          .submenu-enter.submenu-enter-active {
            opacity: 1;
            transition: ${SUBMENU_TRANSITION};
          }

          .submenu-leave {
            opacity: 1;
          }

          .submenu-leave.submenu-leave-active {
            opacity: 0.01;
            transition: ${SUBMENU_TRANSITION};
          }
        }

        .absolute-unified-links {
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          transform: translateY(8px);
          transition: ${UNIFIED_HEADER_TRANSITION_LINKS_DISSAPPEAR};
        }
      }

      .right-side-header-links {
        flex-shrink: 0;
      }

      .header-button-wrapper {
        flex-shrink: 0;
      }
      &.universe-header-desktop-content {
        &.products-with-tags {
          .sections-header-menu-component {
            .header-menu-sections-wrapper {
              .sections-separator {
                &.mondayProducts {
                  margin-right: 64px;
                }
              }
              .header-menu-section-component-wrapper {
                &.has-background-color {
                  padding-top: 48px;
                  padding-bottom: 32px;
                }
                padding-top: 48px;
                &.products:first-of-type {
                  .header-menu-section-title {
                    font-size: 1.238rem;
                    margin-bottom: 16px;
                    margin-right: 80px;
                    color: unset;
                    font-weight: 500;
                  }
                  .header-menu-section-subtitle {
                    font-size: 0.8125rem;
                    line-height: 20px;
                    margin-right: 50px;
                    color: ${Colors.asphalt};
                  }
                }
                &.products {
                  width: 312px;
                }
                &.mondayProducts {
                  .menu-item-title {
                    opacity: 0.85;
                  }
                  padding-top: 30px;
                  .header-menu-section-items-wrapper.mondayProducts {
                    margin-top: 0;
                  }
                }
                .header-menu-section-items-wrapper {
                  .header-menu-section-item-component-wrapper {
                    &.secondary-product {
                      width: 340px;
                      .menu-item-title {
                        opacity: 0.85;
                      }
                    }
                    &.product {
                      width: 576px;
                      height: 116px;
                      padding: 16px 20px 20px;
                      margin-bottom: 14px;
                      @media (max-height: ${CONDENSED_HEADER_SCREEN_HEIGHT}) {
                        margin-bottom: 0;
                      }
                      @media (max-width: ${MD_DESKTOP_WIDTH}) {
                        height: 138px;
                        width: 400px;
                      }
                      @media (max-width: ${HEADER_DESKTOP_MENU_MID_WIDTH}) {
                        // keeping in case needed
                      }
                      &:nth-child(n + 3) {
                        margin-right: 60px;
                      }
                      .header-menu-item-content {
                        height: 100%;
                        align-items: flex-start;
                        .menu-item-text-wrapper {
                          .menu-item-title-icon {
                            margin-top: 8px;
                          }
                          .menu-item-description {
                            -webkit-line-clamp: 3;
                          }
                        }
                        > svg {
                          margin-top: 4px;
                          border-radius: 8px;
                          border: 1px solid var(--icon-stroke-color);
                        }
                      }
                      .menu-item-text-and-tags-wrapper {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 100%;
                        gap: 6px;
                        .menu-item-text-wrapper {
                          gap: 4px;
                          .menu-item-title-wrapper {
                            .menu-item-title {
                              font-size: 1.238rem;
                              line-height: 28px;
                            }
                          }
                          .menu-item-subtitle-wrapper {
                            font-size: 0.8125rem;
                            color: ${Colors.asphalt};
                            line-height: 16px;
                            display: flex;
                            align-items: center;
                            line-height: 1.4;
                            svg {
                              margin-right: 4px;
                              path {
                                color: ${Colors.asphalt};
                                fill: #676879;
                              }
                            }
                          }
                        }
                      }
                      .tags-wrapper {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        flex-wrap: wrap;
                        align-items: center;
                        column-gap: 4px;
                        row-gap: 4px;
                        &.tags-at-the-bottom {
                          display: none;
                        }
                        .tags-title {
                          font-size: 0.6875rem;
                          color: #676879;
                          white-space: nowrap;
                        }
                        .tag-items {
                          display: flex;
                          column-gap: 8px;
                          row-gap: 4px;
                          flex-wrap: wrap;
                        }
                        .tag {
                          padding: 0 4px;
                          font-weight: 400;
                          font-size: 0.6875rem;
                          line-height: 154%;
                          background-color: var(--header-product-tag-background-color);
                          color: var(--header-product-tag-color);
                          border: 1px solid var(--header-product-tag-stroke-color);
                          border-radius: 2px;
                          white-space: nowrap;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          @media (max-width: ${MD_DESKTOP_WIDTH}) {
            .header-menu-section-component-wrapper {
              .header-menu-section-items-wrapper {
                .header-menu-section-item-component-wrapper.product {
                  .tag-items {
                    max-width: 232px;
                  }
                }
              }
            }
            .sections-separator.products {
              margin-right: 40px;
            }
          }
        }
        .link-item-with-menu-component-wrapper {
          position: relative;
          &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1px;
            background-color: transparent;
          }
          &.is-open {
            &:after {
              background-color: ${Colors[DARK_WORK_OS_IRIS_COLOR_NAME]};
            }
          }
        }
        .sections-header-menu-component {
          padding: 0;
          box-shadow: none;

          .header-menu-section-component-wrapper {
            padding: 32px 0 0px;
            background-color: var(--section-background-color);
            min-height: 400px;
            &.has-background-color {
              flex: 1;
              padding-left: 54px;
            }
            .header-menu-section-title {
              color: ${Colors.asphalt};
              font-weight: 300;
              font-size: 0.8125rem;
              display: flex;
              align-items: center;
              svg {
                margin-right: 8px;
                stroke: ${Colors.asphalt};
              }
            }
          }
        }
        .sections-separator {
          border-color: #f0f3ff;
          margin-bottom: 36px;
          margin-top: 32px;
          &.products {
            margin-right: 80px;
          }
        }
        .header-menu-section-item-component-wrapper {
          border-radius: 4px;
          border-width: 2px;
          border-style: solid;
          &:not(.outline) {
            border-color: transparent;
          }
          &.product {
            width: 423px;
            height: 119px;
            padding: 40px 20px;
            margin-bottom: 24px;
            margin-right: 24px;
            &:nth-child(n + 3) {
              margin-right: 100px;
            }
            img {
              height: 26px;
            }
          }
          &.use-case {
            height: 54px;
            width: 187px;
            padding: 14px 8px;
            margin-bottom: 24px;
            &:nth-child(n + 5) {
              margin-right: 60px;
            }
          }
          &.use-case-by-workflow {
            width: 290px;
          }
          &.feature {
            width: 280px;
            margin-bottom: 14px;
            margin-right: 14px;
            padding: 16px 12px;
            .menu-item-title-icon {
              background-color: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};
              border: 1px solid transparent;
              border-radius: 2px;
              margin-right: 12px;
            }
            &:hover {
              .menu-item-title-icon {
                border: ${`1px solid ${Colors[LIGHT_WORK_OS_IRIS_COLOR_NAME]}`};
              }
            }
          }
          &.resource {
            width: 274px;
            margin-bottom: 14px;
            margin-right: 28px;
          }
          &.story {
            background-color: white;
            height: unset;
            width: 356px;
            padding: 0;
            border: none;
            &:hover {
              ${getComponentShadowFilter()}
              // remove hover effect in safari because of this bug: https://monday.monday.com/boards/757661511/pulses/2181485781
              @media not all and (min-resolution: 0.001dpcm) {
                @supports (-webkit-appearance: none) {
                  filter: unset;
                }
              }
            }
            &:not(:last-child) {
              margin-bottom: 20px;
            }
            img {
              width: 100%;
              height: 147px;
              background: ${Colors.silver};
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
            }
            .menu-item-text-wrapper {
              padding: 8px 20px 16px;
              .menu-item-description {
                font-size: 0.8125rem;
                line-height: 19px;
                color: ${Colors.mud};
              }
            }
          }
          .header-menu-section-item-component {
            .header-menu-item-content-and-tags-wrapper {
              display: flex;
              flex-direction: column;
              gap: 4px;
              .header-menu-item-content {
                &.no-description {
                  align-items: center;
                  .menu-item-text-wrapper {
                    .menu-item-description {
                      display: none;
                    }
                  }
                }
              }
            }
          }
        }
        @media (max-width: ${MD_DESKTOP_WIDTH}) {
          .sections-separator.products {
            margin-right: 60px;
          }

          .header-menu-section-item-component-wrapper {
            &.product {
              width: 380px;
              &:nth-child(n + 3) {
                margin-right: 80px;
              }
            }
            &.story {
              width: 280px;
              img {
                height: 115px;
              }
            }
            &.use-case {
              &:nth-child(n) {
                margin-right: 8px;
              }
              &:nth-child(n + 5) {
                margin-right: 40px;
              }
            }
          }
        }
        @media (max-width: ${HEADER_DESKTOP_MENU_MID_WIDTH}) {
          .header-menu-sections-wrapper {
            .header-menu-section-component-wrapper {
              &.use-cases {
                .header-menu-section-items-wrapper {
                  grid-template-rows: repeat(4, auto);
                }
              }
              .header-menu-section-items-wrapper {
                .header-menu-section-item-component-wrapper {
                  &.product {
                    width: 380px;
                    &:nth-child(n + 3) {
                      margin-right: 50px;
                    }
                  }
                  &.use-case {
                    &:nth-child(n + 3) {
                      margin-right: 50px;
                    }
                  }
                  &.resource {
                    &:nth-child(n) {
                      margin-right: 14px;
                    }
                  }
                  &.story {
                    width: 240px;
                    img {
                      height: 99px;
                    }
                  }
                }
              }
            }
            .sections-separator {
              &.products {
                margin-right: 30px;
              }
              &.use-cases {
                margin-right: 30px;
              }
            }
          }
        }
      }
    }

    .header-menu-component-wrapper {
      position: fixed;
      top: ${BASIC_HEADER_HEIGHT};
      z-index: ${TOP_BAR};
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(4px); // currently not supported in Firefox
      pointer-events: none;
      width: 100%;

      .menu-component-wrapper {
        pointer-events: all;
      }
    }

    .secondary-header-wrapper {
      height: ${SECONDARY_HEADER_HEIGHT};
      position: fixed;
      width: 100%;
      z-index: ${TOP_BAR - 1};
    }

    &.with-work-management {
      .base-header-desktop-content.universe-header-desktop-content.products-with-tags {
        &.new-header-layout {
          .sections-header-menu-component .header-menu-sections-wrapper {
            .sections-separator.mondayProducts {
              margin: 0;
            }
            .header-menu-section-component-wrapper {
              min-height: 320px;
              &.moreProducts {
                .menu-item-text-and-tags-wrapper {
                  gap: 8px;
                  .menu-item-text-wrapper {
                    .menu-item-title-wrapper .menu-item-title {
                      font-weight: 300;
                    }
                  }
                }
              }
              &.mondayProducts {
                padding-top: 0;
                &:first-of-type {
                  .header-menu-section-component {
                    .header-menu-section-items-wrapper {
                      &.mondayProducts {
                        padding-top: 40px;
                      }
                    }
                  }
                }
                .header-menu-section-component {
                  .header-menu-section-items-wrapper.mondayProducts {
                    margin-right: 20px;
                    display: flex;
                    height: 100%;
                    .header-menu-section-item-component-wrapper.product {
                      width: 394px;
                      height: 194px;
                      padding: 16px;
                      margin-right: 16px;
                      .header-menu-section-item-component {
                        padding: 40px 0;
                        .header-menu-item-content-and-tags-wrapper {
                          width: 100%;
                          .header-menu-item-content {
                            .menu-item-title-icon {
                              margin-right: 0;
                              margin-bottom: 8px;
                            }
                          }
                        }
                      }
                      .menu-item-text-and-tags-wrapper .menu-item-text-wrapper {
                        .menu-item-subtitle-wrapper {
                          font-size: 0.875rem;
                          margin-bottom: 8px;
                        }
                      }
                      .header-menu-item-content {
                        flex-direction: column;
                        > svg {
                          height: 38px;
                          width: auto;
                          padding: 0;
                          border: none;
                        }
                      }
                      .tags-wrapper {
                        flex-direction: row;
                        .tags-title {
                          width: 100%;
                        }
                        &.tags-next-to-logo {
                          display: flex;
                        }
                        &.tags-at-the-bottom {
                          display: none;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .sections-header-menu-component .header-menu-sections-wrapper {
          .sections-separator.mondayProducts {
            margin-right: 32px;
            @media (max-width: ${MD_DESKTOP_WIDTH}) {
              margin-right: 32px;
            }
          }
          .header-menu-section-component-wrapper {
            &.moreProducts {
              padding-top: 40px;
              .header-menu-section-component {
                .header-menu-section-items-wrapper {
                  &.moreProducts {
                    margin-top: 20px;
                    .header-menu-section-item-component-wrapper {
                      &.secondary-product {
                        width: 156px;
                        height: 54px;
                        margin-bottom: 12px;
                        .header-menu-section-item-component
                          .header-menu-item-content
                          .menu-item-text-wrapper
                          .menu-item-description {
                          -webkit-line-clamp: 3;
                        }
                      }
                    }
                  }
                }
              }
            }
            &.mondayProducts {
              &:first-of-type {
                .header-menu-section-component {
                  .header-menu-section-items-wrapper {
                    &.mondayProducts {
                      padding-top: 16px;
                    }
                  }
                }
              }
              .header-menu-section-component {
                .header-menu-section-title {
                  .monday-markup-language-component {
                    font-weight: 700;
                    font-size: 1.238rem;
                    line-height: 24px;
                    color: ${Colors.asphalt};
                  }
                }
                .header-menu-section-subtitle {
                  .monday-markup-language-component {
                    font-weight: 300;
                    font-size: 0.8125rem;
                    line-height: 24px;
                    color: ${Colors.asphalt};
                    padding-bottom: 24px;
                  }
                }
                .header-menu-section-items-wrapper {
                  &.mondayProducts {
                    margin-left: -24px;
                    padding-top: 40px;
                    .header-menu-section-item-component-wrapper {
                      &.product {
                        margin-right: 100px;
                        margin-right: 24px;
                        height: 118px;
                        .header-menu-item-content {
                          svg {
                            padding: 2px;
                          }
                        }
                        @media (max-width: ${MD_DESKTOP_WIDTH}) {
                          width: 500px;
                          height: 118px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      @media (max-width: ${MD_DESKTOP_WIDTH}) {
        .base-header-desktop-content.universe-header-desktop-content.products-with-tags
          .sections-header-menu-component
          .header-menu-sections-wrapper
          .header-menu-section-component-wrapper
          .header-menu-section-items-wrapper
          .header-menu-section-item-component-wrapper.product
          .tags-wrapper {
          &.tags-next-to-logo {
            display: none;
          }
          &.tags-at-the-bottom {
            display: flex;
            align-items: center;
            .tags-title {
              font-size: 0.6875rem;
              padding-top: 1px;
            }
          }
        }

        .base-header-desktop-content.universe-header-desktop-content.products-with-tags
          .sections-header-menu-component
          .header-menu-sections-wrapper
          .header-menu-section-component-wrapper.mondayProducts
          .header-menu-section-component
          .header-menu-section-items-wrapper.mondayProducts
          .header-menu-section-item-component-wrapper.product
          .header-menu-item-content
          svg {
          width: 48px;
          height: 48px;
          padding: 0;
          border-radius: 6px;
        }
      }

      @media (max-width: ${MD_DESKTOP_WIDTH}) {
        .base-header-desktop-content.universe-header-desktop-content.products-with-tags.new-header-layout
          .sections-header-menu-component
          .header-menu-sections-wrapper
          .header-menu-section-component-wrapper.mondayProducts {
          &:nth-of-type(3) {
            margin-right: 24px;
          }
          &:nth-of-type(1),
          &:nth-of-type(3) {
            .header-menu-section-component {
              .header-menu-section-items-wrapper.mondayProducts {
                .header-menu-section-item-component-wrapper.product {
                  .menu-item-text-and-tags-wrapper .menu-item-text-wrapper .menu-item-subtitle-wrapper {
                    width: 172px;
                  }
                }
              }
            }
          }
          .header-menu-section-component {
            .header-menu-section-items-wrapper.mondayProducts {
              margin-left: unset;
              margin-right: 0;
              .header-menu-section-item-component-wrapper.product {
                width: 312px;
                height: 236px;
                padding-right: 24px;
                padding-left: 24px;
                .menu-item-text-and-tags-wrapper {
                  .menu-item-text-wrapper .menu-item-subtitle-wrapper {
                    width: 200px;
                  }
                  .header-menu-item-content svg {
                    width: revert;
                    height: revert;
                  }
                  .tags-wrapper {
                    max-width: 260px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
